var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((5),function(i){return _c('span',{key:i,staticClass:"SkeletonBox",style:({ height: _vm.height, width: _vm.width })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }